/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignPipelineConfigShowPathParams,
	CampaignPipelineConfigShowResponse,
} from '../types/CampaignPipelineConfigShow'

/**
 * GET /campaigns/:campaign/pipeline-config
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignPipelineConfigController.php CampaignPipelineConfigController::show
 */
export async function campaignPipelineConfigShow(
	campaign: CampaignPipelineConfigShowPathParams['campaign'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignPipelineConfigShowResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/pipeline-config`, config)
}
